import './style.scss';

const ThumbnailGrid = ({ images }: { images: string[] }) => {
    const items = images.slice(0, 4);
    const count = items.length;

    const getClass = () => {
        if (count === 0) return "grid-1"; // 👈 important
        if (count === 1) return "grid-1";
        if (count === 2) return "grid-2";
        if (count === 3) return "grid-3";
        return "grid-4";
    };

    return (
        <div className={`thumb-grid ${getClass()}`}>
            {
                count === 0 ? (
                    <div className="thumb-item">
                        <div className="thumb-placeholder">
                            <i className="ri-image-line" />
                        </div>
                    </div>
                ) : (
                    items.map((img, i) => (
                        <div key={i} className="thumb-item">
                            {img === 'black' ? (
                                <div className="thumb-black">All</div>
                            ) : (
                                <img src={img} alt="" />
                            )}

                            {images.length > 4 && i === 3 && (
                                <div className="thumb-overlay">
                                    +{images.length - 4}
                                </div>
                            )}
                        </div>
                    ))
                )
            }
        </div>
    );
};

export default ThumbnailGrid;